// external
import React from 'react';
import * as Yup from 'yup';
import { SelectOption } from '@americanexpress/dls-react';

import CurrencyInput from 'src/components/formik-fields/currency-input/CurrencyInput';
import BasicInput from 'src/components/formik-fields/basic-input/BasicInput';
import PercentInput from 'src/components/formik-fields/percent-input/PercentInput';
import { LocalDate } from '@js-joda/core';
import DateInput from 'src/components/formik-fields/date-input/DateInput';
import Dropdown from 'src/components/formik-fields/dropdown/Dropdown';
import { AddAccountFormViewModel } from 'src/types/view-models/addAccount/addAccount.view.model';
import AddAccountFormContainer from '../../AddAccountFormContainer';
import LiteralsService from 'src/services/literals/LiteralsService';
import ManualAccountService from 'src/services/manualAccount.service';
import { DebtModelType } from 'src/types/debt.model';

export default function PersonalLoanForm({
    manualAccount,
    onSubmit,
    handleBack
}: AddAccountFormViewModel): JSX.Element {
    return (
        <AddAccountFormContainer
            initialValues={{
                name: '',
                startDate: LocalDate.now(), // TODO how to default to null?
                amount: '',
                interest: 0,
                duration: ''
            }}
            validationSchema={Yup.object({
                name: Yup.string().required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull')),
                startDate: Yup.date().required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull')),
                amount: Yup.string().required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull')),
                interest: Yup.string().required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull')),
                duration: Yup.number().required(LiteralsService.getLiteral('Onboarding.forms.inputValidationNull'))
            })}
            manualAccount={manualAccount}
            onSubmit={(values) => {
                void onSubmit(values, manualAccount, true, DebtModelType.Personal);
            }}
            handleBack={handleBack}
        >
            <BasicInput id="name" label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.name')} />
            <DateInput id="startDate" label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.startDate')} />
            <CurrencyInput
                id="amount"
                label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.originalLoanAmount')}
                hint={LiteralsService.getLiteral('Onboarding.forms.inputHints.theInitialAmountOfYourLoan')}
            />
            <PercentInput
                id="interest"
                label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.interestRate')}
            />
            <Dropdown id="duration" label={LiteralsService.getLiteral('Onboarding.forms.inputLabels.loanDuration')}>
                {ManualAccountService.monthsOptions.map((e) => (
                    <SelectOption key={`manual-account-duration-option-${e}`} value={e}>
                        {e} {LiteralsService.getLiteral('Onboarding.forms.months')}
                    </SelectOption>
                ))}
            </Dropdown>
        </AddAccountFormContainer>
    );
}
